import DraggableItem from 'javascripts/dnd/DraggableItem';

class DraggableFieldPreview extends DraggableItem {
  get field() {
    return this.item;
  }
}

export default DraggableFieldPreview;
